import type { JiraAdminAgentFieldOptionsStepPayload } from '@atlassian/ai-mate-jira-admin-agent-api/jira-admin-agent';

import type { StepNode } from '../../../types';

export type FieldOptionsProps = {
	fieldId: string;
	fieldName: string;
	optionsAdded: string[];
	optionsDisabled: string[];
	optionsRenamed: {
		new: string;
		old: string;
	}[];
};

export const mapFieldOptionsPayload = (steps: StepNode[]): FieldOptionsProps[] => {
	const fieldsById = new Map<string, FieldOptionsProps>();

	for (const step of steps) {
		if (step.actionSubject !== 'field-options') {
			continue;
		}

		const { operation, changes, fieldId, fieldName } =
			step.payload as JiraAdminAgentFieldOptionsStepPayload['payload'];

		let field = fieldsById.get(fieldId);
		if (!field) {
			field = { fieldId, fieldName, optionsAdded: [], optionsDisabled: [], optionsRenamed: [] };
			fieldsById.set(fieldId, field);
		}

		for (const change of changes) {
			if (operation === 'create' && change.new) {
				field.optionsAdded.push(change.new.optionName);
			} else if (operation === 'disable' && change.old) {
				field.optionsDisabled.push(change.old.optionName);
			} else if (operation === 'update' && change.old && change.new) {
				field.optionsRenamed.push({ new: change.new.optionName, old: change.old.optionName });
			}
		}
	}

	return Array.from(fieldsById.values());
};
